import React from "react";
import { useTheme } from "@/lib/providers";

/* Real brand artwork — supplied by the studio.
   White wordmark on dark theme, black wordmark on light theme. */
const SRC = {
  dark: "/verdict-logo-white.svg",
  light: "/verdict-logo-black.svg",
};

export default function Logo({ size = "md", className = "" }) {
  const { theme } = useTheme();
  const h = size === "lg" ? 44 : size === "sm" ? 24 : 32;
  const src = SRC[theme] || SRC.dark;
  return (
    <img
      src={src}
      alt="Therefore / Verdict — Packaging Audit"
      data-testid="brand-logo"
      className={className}
      style={{ height: h, width: "auto", display: "block" }}
    />
  );
}
